// extracted by mini-css-extract-plugin
export default {"layoutwrapper":"CentralElementLayout_layoutwrapper__umZQS","centralelement":"CentralElementLayout_centralelement__kutNy"};